import styled from 'styled-components';

export const StyledMainMenuBlock = styled.div`
  min-width: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: 100svh;
  margin-right: ${({ isMenuOpen }) => (isMenuOpen ? 60 : 0)}px;
  transition: margin-right 0.3s;
  position: fixed;
  z-index: 100000000;
  background: #ebf2f7;
`;

export const StyledMainMenuTopBlock = styled.div`
  width: 100%;
  display: grid;
  justify-items: center;
  grid-gap: 2px;
  align-content: start;
`;

export const StyledMainMenuCommunities = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  bottom: 2px;
  & > a {
    margin-top: 2px;
  }
`;

export const StyledSeparator = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${({ theme }) => theme.color.casper};
  opacity: 50%;
  margin-top: 12px;
  margin-bottom: 12px;
`;

export const StyledFaqButtonBlock = styled.div`
  margin-top: 18px;
  margin-bottom: 10px;
`;

export const StyledGrid3x3ButtonBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  margin-top: 10px;
  background: transparent;
  color: ${({ theme }) => theme.color.textForeground || '#000'};
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.color.muted || 'rgba(0, 0, 0, 0.05)'};
  }

  &.active {
    background: ${({ theme }) => theme.color.primary || '#007bff'};
    color: ${({ theme }) => theme.color.primaryForeground || '#fff'};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.color.ring || '#007bff'};
  }
`;

export const StyledBottomMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
  justify-content: space-between;
`;
